import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    credit_facility_label: {
        id: '_.account_history.credit_facility_account_label',
        defaultMessage: '12 month Flexi-Loan'
    },
    credit_facility_label_dynamic: {
        id: '_.account_history.credit_facility_account_label_dynamic',
        defaultMessage: 'Flexi-Loan'
    },
    longer_credit_facility: {
        id: '_.account_history.longer_credit_facility',
        defaultMessage: '{duration} month Flexi-Loan'
    },
    term_loan_label: {
        id: '_.account_history.term_loan_account_label',
        defaultMessage: 'Business loan'
    },
    iwocapay_label: {
        id: '_.account_history.iwocapay_account_label',
        defaultMessage: 'iwocaPay invoice'
    },
    cbils_label: {
        id: '_.account_history.cbils_account_label',
        defaultMessage: 'CBILS loan'
    },
    flexi24_label: {
        id: '_.account_history.flexi24_account_label',
        defaultMessage: '24 month Flexi-Loan'
    },
    recovery_loan_label: {
        id: '_.account_history.recovery_loan_account_label',
        defaultMessage: 'Recovery loan'
    },
    merchant_cash_advance_label: {
        id: '_.account_history.revenue_based_loan_account_label',
        defaultMessage: 'Revenue Based Loan'
    }
});
